module.exports = __webpack_public_path__ + "img/cactus-pears-350x184.96c8a224.jpg";